/**
 * Header geometry, in one place.
 *
 * These values are published to the host page as CSS custom properties (see
 * LigonierHeader.publishGeometryTokens) so consuming apps can position fixed
 * elements (e.g. the alert banner) relative to the header without hardcoding
 * its dimensions — a header restyle here updates consumers via the deployed
 * bundle, no app redeploy needed. Consumers keep today's values as var()
 * fallbacks for the window before the bundle loads.
 */

/** Height of the fixed header bar (--header-height in the theme tokens). */
export const HEADER_HEIGHT_PX = 56

/**
 * Bottom edge of the fixed mobile search bar shown below the desktop
 * breakpoint: header (56px) + bar (40px input + 2x8px padding = 56px).
 * The bar's sub-768px 1px border paints over whatever sits beneath it, so
 * this value is flush at every width the bar exists.
 */
export const HEADER_STACK_HEIGHT_PX = HEADER_HEIGHT_PX + 56

/**
 * Custom-property names — the public contract with consuming apps. The
 * monorepo references these names with literal fallbacks, so renaming them is
 * a breaking change.
 */
export const HEADER_HEIGHT_TOKEN = '--ligonier-header-height'
export const HEADER_STACK_HEIGHT_TOKEN = '--ligonier-header-stack-height'
